
export const PATTERN_FENCE_ID = 'pattern--fence';

export const PatternFence = () => (
  <pattern
    id={PATTERN_FENCE_ID}
    patternUnits="userSpaceOnUse"
    width={38}
    height={38}
    y={22}
  >
    <path
      fill="none"
      stroke="#666"
      strokeWidth="2"
      d="M1.41 18.92L18.92 1.41l17.49 17.51-17.49 17.49z"
    />
  </pattern>
);

export const PATTERN_FENCE_TOP_ID = 'pattern--fence-top';

export const PatternFenceTop = () => (
  <pattern
    id={PATTERN_FENCE_TOP_ID}
    patternUnits="userSpaceOnUse"
    width={11}
    height={21}
  >
    <path
      fill="#666"
      d="M11.2 10L7.53 0h-3.2L0 11.82l3.67 10h3.2zm-8 1.82l2.73-7.46L8 10l-2.74 7.46z"
    />
  </pattern>
);
